import { render, staticRenderFns } from "./myInfo.vue?vue&type=template&id=28ab1200&"
import script from "./myInfo.vue?vue&type=script&lang=js&"
export * from "./myInfo.vue?vue&type=script&lang=js&"
import style0 from "./myInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports